import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';

export default function CustomPopover({ triggerComponent, children }) {
  return (
    <div className='relative'>
      <Listbox>
        {({ open }) => (
          <>
            <Listbox.Button className='flex items-center'>
              {triggerComponent}
            </Listbox.Button>
            <Transition
              show={open}
              as={Fragment}
              leave='transition ease-in duration-100'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <Listbox.Options className='custom-scrollbar absolute right-0 z-10 mt-3 origin-top-left divide-y divide-gray-100 overflow-auto bg-white shadow-sm ring-1 ring-black ring-opacity-5 focus:outline-none'>
                {children}
              </Listbox.Options>
            </Transition>
          </>
        )}
      </Listbox>
    </div>
  );
}
